// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1hxfM","large":"styles_large__3xEvW"};